/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AmountRemaining
 */
export interface AmountRemaining {
}

/**
 * Check if a given object implements the AmountRemaining interface.
 */
export function instanceOfAmountRemaining(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AmountRemainingFromJSON(json: any): AmountRemaining {
    return AmountRemainingFromJSONTyped(json, false);
}

export function AmountRemainingFromJSONTyped(json: any, ignoreDiscriminator: boolean): AmountRemaining {
    return json;
}

export function AmountRemainingToJSON(value?: AmountRemaining | null): any {
    return value;
}

